import React from "react";
import { Ambience, Reveal, Mono } from "@/components/network/NetworkAtoms";
import { PrimaryCta, SecondaryCta } from "./FundingCta";

export default function FundingClose({ close }) {
  const [l1, l2] = close?.title || ["Tell us what the money is for.", "We'll place it properly."];
  const body = close?.body
    || "Four minutes to submit, no credit search to start the conversation, and a named contact on it from the "
     + "first read to drawdown. At the very least you'll know what your business can raise, and on what terms.";

  return (
    <section className="relative overflow-hidden border-t border-white/10" data-testid="funding-close">
      <Ambience beams={false} />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8 py-20 sm:py-28">
        <Reveal className="max-w-3xl">
          <Mono>Ready when you are</Mono>
          <h2 className="mt-5 font-cabinet text-[34px] sm:text-[48px] leading-[1.03] tracking-[-0.035em] font-semibold text-white">
            {l1}
            <br className="hidden sm:block" /> {l2}
          </h2>
          <p className="mt-5 text-[16px] leading-relaxed text-slate-300 max-w-2xl">
            {body}
          </p>
          <div className="mt-9 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
            <PrimaryCta testId="funding-close-primary" />
            <SecondaryCta testId="funding-close-desk" label="Read the common questions" target="funding-faq" />
          </div>
        </Reveal>

        <Reveal delay={0.12}>
          <div className="mt-16 sm:mt-20 border-t border-white/10 pt-8 max-w-4xl space-y-3">
            <p className="text-[12.5px] leading-relaxed text-slate-500">
              <span className="text-slate-300 font-medium">Connexis Group is not a lender.</span> We are a
              commercial finance desk that presents your application to funders and lenders on our panel. All
              lending decisions, rates and terms are set by the funder, and any agreement you enter into is with
              them rather than with us.
            </p>
            <p className="text-[12.5px] leading-relaxed text-slate-500">
              <span className="text-slate-300 font-medium">You don't pay us.</span> Where a funder proceeds with
              your case they pay us a commission. If a fee were ever payable by you on a particular case, it
              would be disclosed in writing, with the amount, before you committed to anything.
            </p>
            <p className="text-[12.5px] leading-relaxed text-slate-500">
              <span className="text-slate-300 font-medium">Your details are never sold on.</span> Information you
              give us is used to place your application and nothing else. Documents are held in encrypted
              storage. Talking to us involves no credit search; a funder may search your file when they formally
              assess your case, and you'll be told before that happens.
            </p>
            <p className="text-[12.5px] leading-relaxed text-slate-500">
              Commercial finance to limited companies is generally not regulated by the Financial Conduct
              Authority. Where a case involves a regulated product we work only with appropriately authorised
              parties, and the protections that apply to your facility will be explained before you sign.
              Borrowing carries risk: if you don't keep up payments, assets used as security may be at risk.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
